import { render, staticRenderFns } from "./Messages.bkp.vue?vue&type=template&id=59349baf&"
import script from "./Messages.bkp.vue?vue&type=script&lang=js&"
export * from "./Messages.bkp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports